module.exports = __webpack_public_path__ + "img/chevron-up.1732fe2b.svg";